// lib/session.js
import { apiJson } from "./api";

let user = null;
let fetched = false;
let fetching = null;
const STALE_MS = 10 * 60 * 1000;
let lastAt = 0;

export function getUser() {
  return user;
}

export function clearSession() {
  user = null;
  fetched = false;
  lastAt = 0;
  fetching = null;
}

export async function getMeOnce({ force = false } = {}) {
  const stale = Date.now() - lastAt > STALE_MS;
  if (!force && fetched && !stale) return user;
  if (fetching) return fetching;

  fetching = apiJson("/v1/me")
    .then((json) => {
      // ✅ 백엔드 포맷: { user, role }
      user = json?.user ? { ...json.user } : null;
      fetched = true;
      lastAt = Date.now();
      return user;
    })
    .catch(() => {
      user = null;
      fetched = true;
      lastAt = Date.now();
      return null;
    })
    .finally(() => {
      fetching = null;
    });

  return fetching;
}
